import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Navbar from "components/navbars/AdminNavbar.js";
import Sidebar from "components/sidebars/Sidebar.js";
import HeaderStats from "components/headers/HeaderStats.js";
import FooterAdmin from "components/footers/FooterAdmin.js";

import Calendario from "views/admin/Calendario.js";

import Base from "views/admin/logistica/Base.js";
import NaRua from "views/admin/logistica/NaRua.js";
import Distribuir from "views/admin/logistica/Distribuir.js";
import Tables from "views/admin/logistica/Recebidos.js";
import Atribuir from "views/admin/logistica/Atribuir.js";
import Recusados from "views/admin/logistica/Recusados.js"; 

import Registro from "views/admin/gestao/Registro.js";
import Funcionarios from "views/admin/gestao/Funcionarios.js";
import Inativo from "views/admin/gestao/Inativo";
import Liberar from "views/admin/gestao/Liberar";

import Transito from "views/admin/devolucao/Transito";
import Tratativa from "views/admin/devolucao/Tratativa";
import Pacote from "views/admin/devolucao/Pacote";
import AtribuirD from "views/admin/devolucao/Distribuir";
import DistribuirD from "views/admin/devolucao/Atribuir";

import Ocorrencia from "views/admin/administrativo/Ocorrencia.js";
import Contagem from "views/admin/administrativo/Contagem.js";
import Cobranca from "views/admin/administrativo/Cobranca.js";

import Cidades from "views/admin/financeiro/Cidades";
import LiberarL from "views/admin/financeiro/Liberar";
import Pontos from "views/admin/financeiro/Pontos";
import Contabilidade from "views/admin/financeiro/Contabilidade";
import { LocalActivity, LocalSee } from "@mui/icons-material";

export default function Admin() {

  if (localStorage.getItem("fist") === 0 || localStorage.getItem("fist") === null || localStorage.getItem("fist") === undefined) {
    localStorage.setItem("fist", 1);
    window.location.reload();
  }
  const refreshToken = localStorage.getItem("refreshToken");

  if (refreshToken === null) {
    return <Redirect to="/auth/login" />;
  }
   if (localStorage.getItem("cargo") === "MOTORISTA") {

     return <Redirect to="/motorista" />;
       
        }

  return (
    <>
      
      <Sidebar />
      <div className="relative md:ml-64 bg-blueGray-100">
        {/* Header */}
        <div className="hidden md:block">
        <Navbar absolute="absolute top-0 left-0" />

        </div>
        <HeaderStats />
        <div className="px-4 md:px-10 mx-auto w-full -m-24">
          <Switch>
            <Route path="/admin/calendario" exact component={Calendario} />

            <Route path="/admin/logistica/base" exact component={Base} />
            <Route path="/admin/logistica/rua" exact component={NaRua} />
            <Route path="/admin/logistica/distribuir" exact component={Distribuir} />
            <Route path="/admin/logistica/recebidos" exact component={Tables} />
            <Route path="/admin/logistica/atribuir" exact component={Atribuir} />
            <Route path="/admin/logistica/recusados" exact component={Recusados} />

            <Route path="/admin/administrativo/ocorrencia" exact component={Ocorrencia} />
            <Route path="/admin/administrativo/contagem" exact component={Contagem} />
            <Route path="/admin/administrativo/cobranca" exact component={Cobranca} />
            
            <Route path="/admin/gestao/registro" exact component={Registro} />
            <Route path="/admin/gestao/funcionarios" exact component={Funcionarios} />
            <Route path="/admin/gestao/inativo" exact component={Inativo} />
            <Route path="/admin/gestao/liberar" exact component={Liberar} />

            <Route path="/admin/financeiro/pontos" exact component={Pontos} /> 
            <Route path="/admin/financeiro/liberar" exact component={LiberarL} /> 
            <Route path="/admin/financeiro/cidades" exact component={Cidades} /> 
            <Route path="/admin/financeiro/contabilidade" exact component={Contabilidade} /> 

            <Route path="/admin/devolucao/transito" exact component={Transito} /> 
            <Route path="/admin/devolucao/pacote" exact component={Pacote} /> 
            <Route path="/admin/devolucao/tratativa" exact component={Tratativa} /> 
            <Route path="/admin/devolucao/distribuir" exact component={AtribuirD} /> 
            <Route path="/admin/devolucao/atribuir" exact component={DistribuirD} /> 

            <Redirect from="/admin" to="/admin/calendario" />
          </Switch>
          <FooterAdmin />
        </div>
      </div>
      
    </>
  );
}
